import { gql } from 'urql';

const GetSavingsRateInfo = gql`
  query GetSavingsRateInfo {
    savingsRateInfo {
      id
      standardApyBps
      elevatedApyBps
      elevatedBalanceCap {
        amount
        currency
      }
      depositThreshold {
        amount
        currency
      }
      asOfDate
    }
  }
`;

export default GetSavingsRateInfo;
